import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';
const ButtonWrapper = styled(FlexBox)`

`;

const SvgWrapper = styled.div<{isEditProjectPage?: boolean}>`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${({isEditProjectPage}) => isEditProjectPage ? 'none' : 'rgba(24, 26, 28, 0.5)'};
    backdrop-filter: ${({isEditProjectPage}) => isEditProjectPage ? '' : 'blur(2px)'};
    border-radius: 4px;
    padding: 4px 8px;

    svg path {
        fill: #E7E7E7;
        transition: fill 0.2s;
    }
    &:hover {
        svg path {
            fill: #fefefe;
            transition: fill 0.2s;
        }
    }
`;

export const DeleteButton: FC<{ onClick?: () => void, isEditProjectPage?: boolean }> = ({ onClick, isEditProjectPage }) => {

    const handleDeleteClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    }
    
    return (
        (
            <ButtonWrapper style={{ zIndex: 9997 }} width={'100%'} widthMobile={'100%'} justify={'flex-end'} justifyMobile={'flex-end'}>
                <SvgWrapper onClick={handleDeleteClick} isEditProjectPage={isEditProjectPage}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M9.42676 1.96289C8.59833 1.96289 7.92676 2.63446 7.92676 3.46289V3.96289H4.42676C3.59833 3.96289 2.92676 4.63446 2.92676 5.46289V6.46289C2.92676 7.29132 3.59833 7.96289 4.42676 7.96289H4.92676V20.4629C4.92676 21.2913 5.59833 21.9629 6.42676 21.9629H17.4268C18.2552 21.9629 18.9268 21.2913 18.9268 20.4629V7.96289H19.4268C20.2552 7.96289 20.9268 7.29132 20.9268 6.46289V5.46289C20.9268 4.63446 20.2552 3.96289 19.4268 3.96289H15.9268V3.46289C15.9268 2.63446 15.2552 1.96289 14.4268 1.96289H9.42676ZM14.9268 3.96289V3.46289C14.9268 3.18675 14.7029 2.96289 14.4268 2.96289H9.42676C9.15062 2.96289 8.92676 3.18675 8.92676 3.46289V3.96289H14.9268ZM7.92676 4.96289H4.42676C4.15062 4.96289 3.92676 5.18675 3.92676 5.46289V6.46289C3.92676 6.73903 4.15062 6.96289 4.42676 6.96289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 6.96289 19.9268 6.73903 19.9268 6.46289V5.46289C19.9268 5.18675 19.7029 4.96289 19.4268 4.96289H15.9268H15.4268H8.42676H7.92676ZM5.92676 7.96289H17.9268V20.4629C17.9268 20.739 17.7029 20.9629 17.4268 20.9629H6.42676C6.15062 20.9629 5.92676 20.739 5.92676 20.4629V7.96289Z" fill="#E7E7E7"/>
                    </svg>
                </SvgWrapper>
            </ButtonWrapper>
        )
    )
}import { FlexBox } from '@brg/ui';
import { FC } from 'react';
import styled from 'styled-components';
const ButtonWrapper = styled(FlexBox)`

`;

const SvgWrapper = styled.div<{isEditProjectPage?: boolean}>`
    display: flex;
    justify-content: center;
    place-items: center;
    background: ${({isEditProjectPage}) => isEditProjectPage ? 'none' : 'rgba(24, 26, 28, 0.5)'};
    backdrop-filter: ${({isEditProjectPage}) => isEditProjectPage ? '' : 'blur(2px)'};
    border-radius: 4px;
    padding: 4px 8px;

    svg path {
        fill: #E7E7E7;
        transition: fill 0.2s;
    }
    &:hover {
        svg path {
            fill: #fefefe;
            transition: fill 0.2s;
        }
    }
`;

export const DeleteButton: FC<{ onClick?: () => void, isEditProjectPage?: boolean }> = ({ onClick, isEditProjectPage }) => {

    const handleDeleteClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick && onClick();
    }
    
    return (
        (
            <ButtonWrapper style={{ zIndex: 9997 }} width={'100%'} widthMobile={'100%'} justify={'flex-end'} justifyMobile={'flex-end'}>
                <SvgWrapper onClick={handleDeleteClick} isEditProjectPage={isEditProjectPage}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M9.42676 1.96289C8.59833 1.96289 7.92676 2.63446 7.92676 3.46289V3.96289H4.42676C3.59833 3.96289 2.92676 4.63446 2.92676 5.46289V6.46289C2.92676 7.29132 3.59833 7.96289 4.42676 7.96289H4.92676V20.4629C4.92676 21.2913 5.59833 21.9629 6.42676 21.9629H17.4268C18.2552 21.9629 18.9268 21.2913 18.9268 20.4629V7.96289H19.4268C20.2552 7.96289 20.9268 7.29132 20.9268 6.46289V5.46289C20.9268 4.63446 20.2552 3.96289 19.4268 3.96289H15.9268V3.46289C15.9268 2.63446 15.2552 1.96289 14.4268 1.96289H9.42676ZM14.9268 3.96289V3.46289C14.9268 3.18675 14.7029 2.96289 14.4268 2.96289H9.42676C9.15062 2.96289 8.92676 3.18675 8.92676 3.46289V3.96289H14.9268ZM7.92676 4.96289H4.42676C4.15062 4.96289 3.92676 5.18675 3.92676 5.46289V6.46289C3.92676 6.73903 4.15062 6.96289 4.42676 6.96289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 6.96289 19.9268 6.73903 19.9268 6.46289V5.46289C19.9268 5.18675 19.7029 4.96289 19.4268 4.96289H15.9268H15.4268H8.42676H7.92676ZM5.92676 7.96289H17.9268V20.4629C17.9268 20.739 17.7029 20.9629 17.4268 20.9629H6.42676C6.15062 20.9629 5.92676 20.739 5.92676 20.4629V7.96289Z" fill="#E7E7E7"/>
                    </svg>
                </SvgWrapper>
            </ButtonWrapper>
        )
    )
}